import styled, { css } from 'styled-components'

import { FlexCentered } from 'components/common/genericStyles'
import { isIPad } from 'utils/device'

import { tabDesktopBreakpoint } from '../constants'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
`

export const ViewScreen = styled.div`
    background: #fbe8eb;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 3;
    ${FlexCentered};
    flex-direction: column;
    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        width: 98.46%;
        height: 97.12%;
    }
`

export const Image = styled.img`
    width: 100%;
`

export const ImageContainer = styled.div`
    position: absolute;
    width: 81.64%;
    height: 23.97%;
    left: 5.64%;
    top: 11.35%;
    @media only screen and (orientation: landscape) {
        top: 2.34%;
    }
    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        width: 63.47%;
        height: 47.11%;
        left: 5.64%;
        top: 6.34%;
    }
`

export const LottieContainer = styled.div`
    width: 95.83%;
    height: 52.31%;
    position: absolute;
    right: 0;
    bottom: 0;
    @media only screen and (min-width: ${tabDesktopBreakpoint}px) {
        width: 55.41%;
        height: ${isIPad ? '60.24%' : '76.24%'};
    }
`
